import { UI, VStack } from '@genial/components';
import { ColorTypes, Spacing } from '@genial/design-tokens';
import React from 'react';

import { LateralBar } from '../../../../components/LateralBar';

export interface ProductCardProps {
  barColor: ColorTypes.Option;
  children?: React.ReactNode;
}

export const ProductCard: React.FC<ProductCardProps> = ({ barColor, children }) => {
  return (
    <UI.Shadow testId="shadow" level={1} borderRadius="8px" marginY={Spacing['stack.quarck']}>
      <VStack p={Spacing['inset.sm']} position="relative">
        <LateralBar barColor={barColor} />
        {children}
      </VStack>
    </UI.Shadow>
  );
};
